import styled from '@emotion/styled';
import XIcon from '@/public/icons/record/x.svg';
import React from 'react';

type P = {
  onClick: () => void;
};

const Xbutton = ({ onClick }: P) => {
  const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.();
    e.stopPropagation();
  };
  return (
    <ContainerButton type="button" onClick={handleDelete}>
      <XIcon width={10} height={10} stroke={'#888D96'} />
    </ContainerButton>
  );
};

export default Xbutton;

const ContainerButton = styled.button`
  display: flex;
  gap: 4px;
  align-items: center;
  border-radius: 4px;
  padding: 4px;
  :hover {
    background-color: var(--dk-bg-strong, #e7e9ec);
  }
  width: fit-content;
`;
